import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { PdpForm } from '../components/PdpForm';
import { useCreatePdp, usePdp, useUpdatePdp } from '../queries';
import type { PDPInput } from '../api';

export function PdpFormPage() {
  const { publicId = '' } = useParams();
  const isEdit = Boolean(publicId);
  const navigate = useNavigate();

  const pdpQuery = usePdp(isEdit ? publicId : -1);
  const create = useCreatePdp();
  const update = useUpdatePdp(publicId);

  async function handleSubmit(values: PDPInput) {
    const saved = isEdit ? await update.mutateAsync(values) : await create.mutateAsync(values);
    navigate(`/hrm/pdp/${saved.public_id}`);
  }

  if (isEdit && pdpQuery.isPending) {
    return (
      <div className="w-full max-w-3xl space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-96 w-full" />
      </div>
    );
  }

  const pdp = pdpQuery.data;

  return (
    <div className="w-full max-w-3xl space-y-5">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate(isEdit ? `/hrm/pdp/${publicId}` : '/hrm/pdp')}
        >
          <ArrowLeft />
        </Button>
        <h1 className="text-2xl font-semibold tracking-tight">
          {isEdit ? `Edit ${pdp ? pdp.title : 'plan'}` : 'New development plan'}
        </h1>
      </div>

      <PdpForm
        submitLabel={isEdit ? 'Save changes' : 'Create plan'}
        showGoals={!isEdit}
        defaultValues={
          pdp
            ? {
                employee: String(pdp.employee),
                title: pdp.title,
                period: pdp.period,
                status: pdp.status,
                summary: pdp.summary,
              }
            : undefined
        }
        onSubmit={handleSubmit}
        onCancel={() => navigate(isEdit ? `/hrm/pdp/${publicId}` : '/hrm/pdp')}
      />
    </div>
  );
}
